import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=d912b812&scoped=true&"
import script from "./contact-us.vue?vue&type=script&lang=js&"
export * from "./contact-us.vue?vue&type=script&lang=js&"
import style0 from "./contact-us.vue?vue&type=style&index=0&id=d912b812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d912b812",
  null
  
)

export default component.exports